<section class="banner-section">
  <div class="banner-card">
    <div class="banner-content">
      <div class="banner-text">
        <h2 class="banner-title" [innerHTML]="'landing.ad.banner.title' | translate"></h2>
        <p class="banner-subtitle">{{ styleOfMonth()?.name || ('landing.ad.banner.subtitle' | translate) }}</p>
        <app-button
          customIconSrc="/assets/icons/magic-wand.svg"
          [shadow]="false"
          routerLink="project"
          fragment="top"
          [queryParams]="styleOfMonth()?.id ? { styleId: styleOfMonth()?.id } : null"
          [label]="'landing.ad.banner.cta' | translate">
        </app-button>
      </div>
      <div class="banner-image">
        @if (styleImageUrl(); as imageUrl) {
          <img [src]="imageUrl" [alt]="styleOfMonth()?.name || 'Style of the month'" />
        } @else {
          <div class="banner-image-placeholder"></div>
        }
      </div>
    </div>
  </div>
</section>
